import api from './api';

export interface ToolOperationSummary {
  type: 'created' | 'updated' | 'deleted' | 'read' | 'error';
  entity: string;
  description: string;
}

export interface ToolCallRecord {
  id: string;
  name: string;
  args: Record<string, unknown>;
  result: {
    success: boolean;
    data?: unknown;
    error?: string;
  };
}

export interface ChatMessage {
  id: string;
  sender: 'user' | 'assistant';
  content: string;
  contextTokens: number | null;
  createdAt: string;
  threadId: string;
  toolCalls?: ToolCallRecord[] | null;
  hasToolCalls: boolean;
}

export interface ContextMetrics {
  totalTokens: number;
  crmTokens: number;
  chatTokens: number;
}

export interface ChatHistoryResponse {
  messages: ChatMessage[];
  contextMetrics: ContextMetrics | null;
}

export interface SendMessageResponse {
  message: ChatMessage;
  userMessage: ChatMessage;
  contextMetrics: ContextMetrics;
  toolCallSummary?: ToolOperationSummary[];
}

export const crmApi = {
  async getChatHistory(): Promise<ChatHistoryResponse> {
    const response = await api.get<ChatHistoryResponse>('/api/crm/chat');
    return response.data;
  },

  async sendMessage(content: string, focusContactId?: string): Promise<SendMessageResponse> {
    const response = await api.post<SendMessageResponse>('/api/crm/chat', {
      content,
      focusContactId,
    });
    return response.data;
  },

  async clearChatHistory(): Promise<void> {
    await api.delete('/api/crm/chat');
  },
};

export default crmApi;
